import React from 'react';
import { useSelector } from 'react-redux';
import { globalSessionENums, Images, useSecondaryModal, FindLoad } from 'utils';
import { CloseButton } from 'components';
import { ScheduleDetails } from '../../../schedule';

const ACTION_TYPE = 'GET_SESSION_WARNINGS';

const WarningSkeleton = () => (
    <>
        {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="warning-skeleton-item">
                <div className="warning-skeleton-icon" />
                <div className="warning-skeleton-content">
                    <div className="warning-skeleton-line warning-skeleton-line-long" />
                    <div className="warning-skeleton-line warning-skeleton-line-short" />
                </div>
            </div>
        ))}
    </>
);

export const WarningDrawer = ({ handleClose }) => {
    const { therapySession } = useSelector((state) => ({
        therapySession: state.auth.therapySessionEvents?.[globalSessionENums.SESSION_EXPIRED],
    }));
    const { openSecondary } = useSecondaryModal();
    const loading = FindLoad(ACTION_TYPE);

    const expiredApptSessions = therapySession?.evenType === globalSessionENums.SESSION_EXPIRED && therapySession?.data;

    const openAppt = (apptId) => {
        openSecondary(<ScheduleDetails currentId={apptId} />);
    };

    const sessions = expiredApptSessions || [];

    return (
        <div className="warning-drawer-container">
            <div className="warning-drawer-header">
                <h3>Warnings</h3>
                <CloseButton styles={{ width: '35px', height: '35px' }} handleCLic={handleClose} />
            </div>

            <div className="warning-drawer-list">
                {loading?.length ? (
                    <WarningSkeleton />
                ) : sessions.length === 0 ? (
                    <div className="warning-drawer-empty">
                        <img src={Images.warning} alt="warning" style={{ width: 48, height: 48, opacity: 0.3 }} />
                        <p>No warnings at the moment</p>
                    </div>
                ) : (
                    sessions.map((item, index) => (
                        <div key={index} className="warning-drawer-item" onClick={() => openAppt(item?.apptId)}>
                            <div className="warning-drawer-item-icon">
                                <img src={Images.alertWarning} alt="warning" />
                            </div>
                            <div className="warning-drawer-item-content">
                                <p className="warning-drawer-item-title">Session time ended</p>
                                <p className="warning-drawer-item-subtitle">
                                    The scheduled end time for appointment
                                    <br />
                                    <span className="warning-drawer-appt-id">{item?.apptDisplayId}</span> has passed.
                                </p>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};
